var map = {
	"./end_recording.mp3": 3274,
	"./start_recording.mp3": 3275
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 386;



//////////////////
// WEBPACK FOOTER
// ./assets/sounds/speech-to-text .\.mp3*
// module id = 386
// module chunks = 0